import React from 'react';
import {SvgProps} from 'react-native-svg';

import CartCountBadge from '../../components/cart/CartCountBadge';

const TAB_BAR_ICON_SIZE = 64;

type TabBarIconComponent = React.FC<SvgProps>;

export const tabBarIcon =
  (Icon: TabBarIconComponent, badge = false, testID?: string) =>
  ({color}: {focused: boolean; color: string; size: number}) => (
    <>
      <Icon
        width={TAB_BAR_ICON_SIZE}
        height={TAB_BAR_ICON_SIZE}
        fill={color}
        color={color}
        testID={testID}
      />
      {!!badge && <CartCountBadge />}
    </>
  );

export const rewardsTabBarIcon =
  (Icon: TabBarIconComponent, FocusedIcon: TabBarIconComponent) =>
  ({focused}: {focused: boolean; color: string; size: number}) => {
    const Component = focused ? FocusedIcon : Icon;
    return <Component width={TAB_BAR_ICON_SIZE} height={TAB_BAR_ICON_SIZE} />;
  };
